import LastVisited from './LastVisited';

export default LastVisited;


// WEBPACK FOOTER //
// ./src/components/LastVisited/index.tsx